export default __webpack_public_path__ + "static/media/miPerfil.aca42bf0.svg";